<template>
  <v-card class="white--text indigo">
    <div v-if="!outstanding" class="text-h6 p-3">No account set</div>
    <div class="d-flex flex-column p-3">
      <div class="text-h6 mb-2">{{ configObj.displayName }}</div>
      <div class="text-h4">{{ outstanding }}</div>
    </div>
    <dashboard-configuration 
      :config="config" 
      :showConfigDialog="showConfigDialog"
      @onConfigureClose="onConfigureClose"
      @onNewConfig="onNewConfig"
      />      
  </v-card>
</template>

<script>
import DashboardConfiguration from './DashboardConfiguration.vue';
import AccountDatesConfig from './AccountDatesConfig.js';

export default {
  name: "OutstandingBalance",
  components: {
    DashboardConfiguration
  },
  displayName: () => {
    return "Balance";
  },
  md: 4,
  props: {
    id: {
      type: String,
      default: "",
    },
    showConfigDialog: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  async created() {
    await this.$store.dispatch("getTransactions");
    await this.$store.dispatch("getAccounts");
    this.configObj = new AccountDatesConfig(this.config);
  },
  data: () => ({
    configObj: new AccountDatesConfig({}),
    noAccount: false,
  }),
  computed: {
    displayConfigDialog() {
      return this.showConfigDialog || this.noAccount;
    },
    outstanding() {
      if (!this.configObj.account) {
        return undefined;
      }

      const registerEntries = this.$store.getters["filterRegisterEntries"](
        this.configObj.account,
        undefined,
        this.configObj.dateRange
      );
      const balance = registerEntries.totalAmount
        ? this.$options.filters.formatAmount(registerEntries.totalAmount)
        : "0.0";
      return balance;
    },
  },
  methods: {
    onConfigureClose() {
      this.$emit("onConfigureClose", this.id);
    },
    onNewConfig(configJson) {
      this.configObj = new AccountDatesConfig(configJson);
      this.$emit("onNewConfig", this.id, configJson);
    }
  },
};
</script>